module.exports = __webpack_public_path__ + "f841b176dcbff7f0ef98091b9184b8b1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arcade/arcade.regular.ttf
// module id = 377
// module chunks = 0